export const OLD_TESTAMENT_BOOKS = [
  {
    name: 'Genesis',
    code: 'gen',
    numChapters: 50,
  },
  {
    name: 'Exodus',
    code: 'exo',
    numChapters: 40,
  },
  {
    name: 'Leviticus',
    code: 'lev',
    numChapters: 27,
  },
  {
    name: 'Numbers',
    code: 'num',
    numChapters: 36,
  },
  {
    name: 'Deuteronomy',
    code: 'deut',
    numChapters: 34,
  },
  {
    name: 'Joshua',
    code: 'josh',
    numChapters: 24,
  },
  {
    name: 'Judges',
    code: 'judg',
    numChapters: 21,
  },
  {
    name: 'Ruth',
    code: 'ruth',
    numChapters: 4,
  },
  {
    name: '1 Samuel',
    code: '1sam',
    numChapters: 31,
  },
  {
    name: '2 Samuel',
    code: '2sam',
    numChapters: 24,
  },
  {
    name: '1 Kings',
    code: '1kgs',
    numChapters: 22,
  },
  {
    name: '2 Kings',
    code: '2kgs',
    numChapters: 25,
  },
  {
    name: '1 Chronicles',
    code: '1chr',
    numChapters: 29,
  },
  {
    name: '2 Chronicles',
    code: '2chr',
    numChapters: 36,
  },
  {
    name: 'Ezra',
    code: 'ezra',
    numChapters: 10,
  },
  {
    name: 'Nehemiah',
    code: 'neh',
    numChapters: 13,
  },
  {
    name: 'Esther',
    code: 'esth',
    numChapters: 10,
  },
  {
    name: 'Job',
    code: 'job',
    numChapters: 42,
  },
  {
    name: 'Psalms',
    code: 'psa',
    numChapters: 150,
  },
  {
    name: 'Proverbs',
    code: 'prov',
    numChapters: 31,
  },
  {
    name: 'Ecclesiastes',
    code: 'eccl',
    numChapters: 12,
  },
  {
    name: 'Song of songs',
    code: 'song',
    numChapters: 8,
  },
  {
    name: 'Isaiah',
    code: 'isa',
    numChapters: 66,
  },
  {
    name: 'Jeremiah',
    code: 'jer',
    numChapters: 52,
  },
  {
    name: 'Lamentations',
    code: 'lam',
    numChapters: 5,
  },
  {
    name: 'Ezekiel',
    code: 'ezek',
    numChapters: 48,
  },
  {
    name: 'Daniel',
    code: 'dan',
    numChapters: 12,
  },
  {
    name: 'Hosea',
    code: 'hos',
    numChapters: 14,
  },
  {
    name: 'Joel',
    code: 'joel',
    numChapters: 3,
  },
  {
    name: 'Amos',
    code: 'amos',
    numChapters: 9,
  },
  {
    name: 'Obadiah',
    code: 'obad',
    numChapters: 1,
  },
  {
    name: 'Jonah',
    code: 'jon',
    numChapters: 4,
  },
  {
    name: 'Micah',
    code: 'mic',
    numChapters: 7,
  },
  {
    name: 'Nahum',
    code: 'nah',
    numChapters: 3,
  },
  {
    name: 'Habakkuk',
    code: 'hab',
    numChapters: 3,
  },
  {
    name: 'Zephaniah',
    code: 'zeph',
    numChapters: 3,
  },
  {
    name: 'Haggai',
    code: 'hag',
    numChapters: 2,
  },
  {
    name: 'Zechariah',
    code: 'zech',
    numChapters: 14,
  },
  {
    name: 'Malachi',
    code: 'mal',
    numChapters: 4,
  },
];

export const NEW_TESTAMENT_BOOKS = [
  {
    name: 'Matthew',
    code: 'matt',
    numChapters: 28,
  },
  {
    name: 'Mark',
    code: 'mark',
    numChapters: 16,
  },
  {
    name: 'Luke',
    code: 'luke',
    numChapters: 24,
  },
  {
    name: 'John',
    code: 'john',
    numChapters: 21,
  },
  {
    name: 'Acts',
    code: 'acts',
    numChapters: 28,
  },
  {
    name: 'Romans',
    code: 'rom',
    numChapters: 16,
  },
  {
    name: '1 Corinthians',
    code: '1cor',
    numChapters: 16,
  },
  {
    name: '2 Corinthians',
    code: '2cor',
    numChapters: 13,
  },
  {
    name: 'Galatians',
    code: 'gal',
    numChapters: 6,
  },
  {
    name: 'Ephesians',
    code: 'eph',
    numChapters: 6,
  },
  {
    name: 'Philippians',
    code: 'phil',
    numChapters: 4,
  },
  {
    name: 'Colossians',
    code: 'col',
    numChapters: 4,
  },
  {
    name: '1 Thessalonians',
    code: '1the',
    numChapters: 5,
  },
  {
    name: '2 Thessalonians',
    code: '2the',
    numChapters: 3,
  },
  {
    name: '1 Timothy',
    code: '1tim',
    numChapters: 6,
  },
  {
    name: '2 Timothy',
    code: '2tim',
    numChapters: 4,
  },
  {
    name: 'Titus',
    code: 'titus',
    numChapters: 3,
  },
  {
    name: 'Philemon',
    code: 'phile',
    numChapters: 1,
  },
  {
    name: 'Hebrews',
    code: 'heb',
    numChapters: 13,
  },
  {
    name: 'James',
    code: 'jam',
    numChapters: 5,
  },
  {
    name: '1 Peter',
    code: '1pet',
    numChapters: 5,
  },
  {
    name: '2 Peter',
    code: '2pet',
    numChapters: 3,
  },
  {
    name: '1 John',
    code: '1joh',
    numChapters: 5,
  },
  {
    name: '2 John',
    code: '2joh',
    numChapters: 1,
  },
  {
    name: '3 John',
    code: '3joh',
    numChapters: 1,
  },
  {
    name: 'Jude',
    code: 'jude',
    numChapters: 1,
  },
  {
    name: 'Revelation',
    code: 'rev',
    numChapters: 22,
  }
];

export const BOOKS = [
  ...OLD_TESTAMENT_BOOKS,
  ...NEW_TESTAMENT_BOOKS,
];

export default BOOKS;
